var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":"0 0 24 24","role":"presentation","focusable":"false","xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}},[_c('path',{attrs:{"d":"M12.65 10A5.99 5.99 0 007 6c-3.31 0-6 2.69-6 6s2.69 6 6 6a5.99 5.99 0 005.65-4H17v4h4v-4h2v-4H12.65zM7 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }